// extracted by mini-css-extract-plugin
export default {"discountListModal":"discount-code-details-modal_discountListModal__ijxLH"};